<template>
  <div class="font-weight-bold d-flex justify-space-between align-end">
    <v-chip label :style="style('A')">
      Team A ({{ wordsMissing.teamA }})
    </v-chip>
    <div class="text-center">
      Turn of<br />
      <v-chip label :style="style(currentTeam)">
        Team {{ currentTeam }}
      </v-chip>
    </div>
    <v-chip label :style="style('B')">
      Team B ({{ wordsMissing.teamB }})
    </v-chip>
  </div>
</template>

<script>
import colors from '../utils/colors';
import textColor from '../utils/textColor';

export default {
  name: 'StatusBar',
  props: {
    currentTeam: {
      type: String,
      required: true,
    },
    wordsMissing: {
      type: Object,
      required: true,
    },
  },
  methods: {
    style(team) {
      const teamColor = team === 'A' ? colors.teamA : colors.teamB;

      return {
        'background-color': teamColor,
        color: textColor(teamColor),
        fontWeight: 'bold',
      };
    },
  },
};
</script>

<style scoped></style>
